import TableViewStyles from './TableView.Styles.js';
import React from 'react'
import { TableContainer, Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";

const merge = (target, source, mutable = false) => {
    const newObj = typeof target == 'object' ? (mutable ? target : Object.assign({}, target)) : {};
    for (const prop in source) {
        if (target[prop] == null || typeof target[prop] === 'undefined') {
            newObj[prop] = source[prop];
        } else if (Array.isArray(target[prop])) {
            newObj[prop] = source[prop] || target[prop];
        } else if (target[prop] instanceof RegExp) {
            newObj[prop] = source[prop] || target[prop];
        } else {
            newObj[prop] = typeof source[prop] === 'object' ? merge(target[prop], source[prop]) : source[prop];
        }
    }
    return newObj;
};

export default function TableView(props) {
    const style = props.style ? merge(TableViewStyles(), props.style) : TableViewStyles();

    return (
        <TableContainer style={{ ...{ position: "relative" }, ...style.Container }}>
            <Table stickyHeader style={style.TableSX} aria-label="sticky table">
                <TableHead style={{ position: "sticky", top: 0, zIndex: 30 }}>
                    {props.headers.map((row, i) => {
                        if (row.length > 0)
                            return (
                                <TableRow key={`header-${i}`} style={row.style ?? {}}>
                                    {row.map((cell, index) => {
                                        if (index < props.fixedColumns && (i == 0 || !props.headers[i - 1][index]?.rowspan))
                                            return (
                                                <TableCell colSpan={cell?.colspan} rowSpan={cell?.rowspan} style={{ ...style.Header, ...style.FixedColumn, ...cell?.style ?? {} }}>
                                                    {cell?.text || cell}
                                                </TableCell>
                                            );
                                        else
                                            return (
                                                <TableCell colSpan={cell?.colspan} rowSpan={cell?.rowspan} style={{ ...style.Header, ...cell?.style ?? {} }}>
                                                    {cell?.text || cell}
                                                </TableCell>
                                            );
                                    })}
                                </TableRow>
                            );
                    })}
                </TableHead>
                <TableBody>
                    {props.rows === undefined ? null : props.rows?.map((row, i) => {
                        if ((row.cells || row).length > 0)
                            return (
                                <TableRow key={`row-${i}`} style={row.style ?? {}}>
                                    {(row.cells || row).map((cell, index) => {
                                        if (index < props.fixedColumns)
                                            return (
                                                <TableCell colSpan={cell?.colspan} rowSpan={cell?.rowspan} component="th" scope="row" style={{ ...style.Body, ...style.FixedColumn, ...row.style ?? {}, ...cell?.style ?? {} }}>
                                                    {cell?.text || cell}
                                                </TableCell>
                                            );
                                        else
                                            return (
                                                <TableCell colSpan={cell?.colspan} rowSpan={cell?.rowspan} style={{ ...style.Body, ...row.style ?? {}, ...cell?.style ?? {} }}>
                                                    {cell?.text || cell}
                                                </TableCell>
                                            );
                                    })}
                                </TableRow>
                            );
                    })}
                    {props.footers === undefined ? null : props.footers?.map((row, i) => {
                        if (row.length > 0)
                            return (
                                <TableRow key={`footer-${i}`} style={row.style ?? {}}>
                                    {row.map((cell, index) => {
                                        if (index < props.fixedColumns)
                                            return (
                                                <TableCell colSpan={cell?.colspan} rowSpan={cell?.rowspan} component="th" scope="row" style={{ ...style.Footer, ...style.FixedColumn, ...cell?.style ?? {} }}>
                                                    {cell?.text || cell}
                                                </TableCell>
                                            );
                                        else
                                            return (
                                                <TableCell colSpan={cell?.colspan} rowSpan={cell?.rowspan} style={{ ...style.Footer, ...cell?.style ?? {} }}>
                                                    {cell?.text || cell}
                                                </TableCell>
                                            );
                                    })}
                                </TableRow>
                            );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
